import React, { useContext, useEffect, useState } from 'react';
import { Checkbox, Header } from "@amzn/awsui-components-react/polaris";
import OpenCalculationReviewsGrid from "./OpenCalculationReviewsGrid";
import { OpenCalcReviewsSearchRequest } from 'src/models/dashboard/OpenCalculationReview';
import { getAllCalcReviewsSearchPayload } from "src/components/dashboard/helpers/OpenCalculationReviewsSearchHelper";
import { PropertyFilterQuery } from "@amzn/awsui-collection-hooks";
import { convertPropertyFilterQueryToDbMainExpression } from "./helpers/PropertyFilterHelper";
import { GlobalAppContext } from "../App";

export default function AllCalculationReviewsView() {
    const { services } = useContext(GlobalAppContext);
    
    const [isAllUsersViewChecked, setIsAllUsersViewChecked] = React.useState(false);

    const [allCalcReviewsSearchPayload, setAllCalcReviewsSearchPayload] = useState(undefined as OpenCalcReviewsSearchRequest | undefined);
    const [allCalcReviewsResult, isSearchingCalcReviews, searchCalcReviewsError] = services.dashboardService.searchOpenCalculationReviews(allCalcReviewsSearchPayload);

    document.body.classList.add('white-background');

    useEffect(() => {
        setAllCalcReviewsSearchPayload(getAllCalcReviewsSearchPayload());
    }, [])

    const setUserViewMode = (payload?: OpenCalcReviewsSearchRequest) => {
        if (payload == null){
            return;
        }
        if (isAllUsersViewChecked){
            setAllCalcReviewsSearchPayload({
                ...payload,
                userViewMode: "ALL"
            })
        }
        else {
            setAllCalcReviewsSearchPayload({
                ...payload,
                userViewMode: "SINGLE"
            })
        }
    }

    useEffect(() => {
        if (allCalcReviewsResult == null){
            return;
        }
        allCalcReviewsResult.pagesCount = parseInt(Math.ceil(allCalcReviewsResult.totalSize / allCalcReviewsResult.pageSize).toString());
    }, [allCalcReviewsResult]);
    
    
    useEffect(() => {
        if (allCalcReviewsSearchPayload == null){
            return;
        }
        setUserViewMode(allCalcReviewsSearchPayload);
    }, [isAllUsersViewChecked]);

    const cliReviewFilterChangedHandler = (searchQuery: PropertyFilterQuery) => {
        if (allCalcReviewsSearchPayload == null) {
            return;
        }
        if (searchQuery.tokens.length === 0){
            setUserViewMode(getAllCalcReviewsSearchPayload());
            return;
        }
        setAllCalcReviewsSearchPayload({
            ...allCalcReviewsSearchPayload,
            filterExpression: convertPropertyFilterQueryToDbMainExpression(searchQuery)
        })
    }

    return <div>
                <div className='allUsersViewContainer'>
                    <Checkbox
                        onChange={({ detail }) =>
                            setIsAllUsersViewChecked(detail.checked)
                        }
                        checked={isAllUsersViewChecked}
                        >
                        All users view
                    </Checkbox>
                </div>
                <OpenCalculationReviewsGrid
                    openCalculationReviewsResult={allCalcReviewsResult}
                    isLoading={isSearchingCalcReviews}
                    dashboardView={true}
                    showFilter={true}
                    gridHeader={<Header counter={`(${allCalcReviewsResult?.items.length})`} description="All CLIs assigned to me that have status change from last MEC in ATP">All CLIs</Header>}
                    onFilterQueryChanged={cliReviewFilterChangedHandler}
                    onPageChanged={(page: number) => {
                        if (allCalcReviewsSearchPayload == null){
                            return;
                        }
                        setAllCalcReviewsSearchPayload({
                            ...allCalcReviewsSearchPayload,
                            page: page
                        })
                    }}
                    onSortingChanged={(sortOrder:string, sortField?:string) => {
                        if (allCalcReviewsSearchPayload == null){
                            return;
                        }
                        setAllCalcReviewsSearchPayload({
                            ...allCalcReviewsSearchPayload,
                            sortField: sortField,
                            sortOrder: sortOrder
                        })
                    }}
                />
            </div>
}